// Pure href/string constants for the borrower edit-entity modal — intentionally kept free of any
// component or store imports so lightweight consumers (e.g. the loanNavigation service) can read the
// hrefs without pulling in the full Borrower component tree (which transitively loads FormEditor and
// its ESM-only deps that Jest's transform does not handle). EditEntityModal.constants re-exports these.

export const BORROWING_ENTITY_TABS_HREF = {
  BORROWER: 'personal-info',
  ADDRESS: 'address',
  CREDIT_REPORTING: 'credit-reporting',
  ALTERNATE_NAMES: 'alternate-names',
  POA: 'poa',
  DECLARATIONS: 'declarations',
  CUSTOM_FIELDS: 'custom-fields',
};

export const ENTITY_TYPE_HREF = {
  BORROWER: 'borrower',
  NON_BORROWER: 'nbe',
};

export const NBE_ENTITY_TABS_HREF = {
  NBE_INFO: 'nbe-info',
  CREDIT_REPORTING: 'credit-reporting',
  CUSTOM_FIELDS: 'custom-fields',
};
